import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot,  Router } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Guard de creación de emergencias. Permite el acceso únicamente a usuarios con rol `executor`;
 * redirige al panel del ejecutor en caso contrario.
 */
@Injectable({providedIn: 'root'})

export class CreateEmergencieGuard implements CanActivate {

  private readonly _route = inject(Router)
    private readonly _role = localStorage.getItem("role")

  /**
   * Evalúa si el usuario tiene rol `executor` para crear emergencias.
   * @param route - Snapshot de la ruta a activar
   * @param state - Estado actual del router
   * @returns `Observable<true>` si el rol es `executor`, `Observable<false>` tras redirigir al panel del ejecutor
   */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):Observable<boolean> {
      if(this._role == "executor"){
        return of(true)
      }else{
        void this._route.navigate(["executor"])
        return of(false)
      }


    }
    
}